import { IBrand, useBrandsSlice } from 'entities/Brand';
import { IOffer } from 'entities/Offer';
import { useMeta } from 'shared/hooks';
import { EYmEvents, EYmEventsO1, EYmEventsO2 } from 'shared/typings';
import { sendYmEvent } from 'shared/utils';

export const useJoinOffer = (brand?: IBrand, offer?: IOffer) => {
	const { setJoinedOffer, setOpenedModal } = useBrandsSlice();
	const { sourcesCount, activeSourcesCount, userCanJoinToOffer } = useMeta();

	if (!brand || !offer) {
		return {
			joinIsDisabled: true,
			onJoin: () => {},
		};
	}

	const canJoin = userCanJoinToOffer(offer.sources_relations);

	const joinIsDisabled = !canJoin && activeSourcesCount > 0;

	const onJoin = (o2?: EYmEventsO2, o4?: string) => {
		sendYmEvent({
			event: EYmEvents.CLICK_JOIN,
			o1: [EYmEventsO1.ACCOUNT, EYmEventsO1.PUBLISHER, EYmEventsO1.CATALOG],
			o2: o2 || EYmEventsO2.CATALOG,
			pi: offer.uuid,
			o4,
		});

		if (sourcesCount === 0) {
			setOpenedModal('no_source');
		} else if (activeSourcesCount === 0) {
			setOpenedModal('no_active_source');
		} else {
			setJoinedOffer({ brand: brand, offer: offer });
		}
	};

	return {
		joinIsDisabled,
		onJoin,
	};
};
